import { isAdInventoryTargetingEnabled } from '../formatInventoryTargeting'
import {
  AD_INVENTORY,
  IS_SUB_ALLOCATION
} from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'
import { RIGHT_INVENTORY_SELECT } from '../../fields'
import { getAllOrSpecificInventory } from '../../helpers'

export const getQuantityAllocationInventoryToTarget = (values, right) => {
  const adInventoryTargetingEnabled = isAdInventoryTargetingEnabled(right)
  const isSubAllocation = right[IS_SUB_ALLOCATION]
  const allRightInventory = right[AD_INVENTORY]
  const selectedInventory = values[RIGHT_INVENTORY_SELECT]

  if (isSubAllocation) {
    // for sub-allocation quantity right - we ask user to select placements
    return selectedInventory
  } else {
    // for single allocation quantity right - we either take all placements or specific placements based on targeting option
    if (adInventoryTargetingEnabled) {
      // enabled
      return getAllOrSpecificInventory(values, right)
    } else {
      // when targeting is disabled - we don't show the inventory selection step, we just take all the inventory from right
      return allRightInventory
    }
  }
}
